export class MemberDetail {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  password: string = '';
}

export class SecurityQuestion {
  id: number = 0;
  question: string = '';
  isActive: boolean = false;
}

export class MemberSecurityQuestion {
  questionId: number = 0;
  question: string = '';
  createdAt: string = '';
}

export class LockedAccountSecurityQuestion {
  questionId: number = 0;
  question: string = '';
}

export class SecurityAnswerItem {
  questionId: number = 0;
  answer: string = '';
}

export class SaveMemberSecurityAnswersCommand {
  securityAnswers: SecurityAnswerItem[] = [];
}

export class VerifyMemberSecurityAnswersCommand {
  securityAnswers: SecurityAnswerItem[] = [];
}

export class VerifyLockedMemberSecurityAnswersCommand {
  email: string = '';
  securityAnswers: SecurityAnswerItem[] = [];
}

export class ResendInviteRequest {
  token: string = '';
  email: string = '';
}
